import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { IconDefinition } from '@fortawesome/angular-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '../../services/shared/spinner/spinner.service';
import { ToastService } from '../../services/shared/toast/toast.service';
import { HttpClient } from '@angular/common/http';
import { ContactUsSubmissionService } from '../../services/transactional/contact-us-submission/contact-us-submission.service';
import { ICreateContactUsSubmission } from '../../models/dtos/create/create-contact-us-submission.interface';
import { finalize } from 'rxjs';
import { loadComponentTranslations } from '../../funcs/lang-loader';

@Component({
  selector: 'app-get-in-touch-with-us',
  imports: [TranslateModule, CommonModule, ReactiveFormsModule],
  templateUrl: './get-in-touch-with-us.component.html',
  styleUrl: './get-in-touch-with-us.component.scss',
})
export class GetInTouchWithUsComponent implements OnInit {
  public faUserCircle: IconDefinition = faUserCircle;
  public isLoggedIn: boolean = false;
  @Output('closeModal') public closeModal: EventEmitter<string> =
    new EventEmitter<string>();
  public isSubmitted: boolean = false;
  constructor(
    private titleService: Title,
    private metaService: Meta,
    private _spinnerService: SpinnerService,
    private _toastService: ToastService,
    private _translateService: TranslateService,
    private _ref: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,

    private _http: HttpClient,
    private _contactUsSubmissionService: ContactUsSubmissionService,
  ) {}

  public contactForm: FormGroup = new FormGroup({
    name: new FormControl<string | undefined>(undefined, [Validators.required]),
    email: new FormControl<string | undefined>(undefined, [
      Validators.required,
      Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
    ]),
    phone: new FormControl<string | undefined>(undefined, [
      Validators.required,
    ]),
    subject: new FormControl<string | undefined>(undefined, [
      Validators.required,
    ]),
    message: new FormControl<string | undefined>(undefined, [
      Validators.required,
    ]),
  });

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public ngOnInit(): void {
    loadComponentTranslations(
      this._http,
      this._translateService,
      'forms/get-in-touch-with-us',
      this.isBrowser(),
    ).subscribe({
      next: () => {},
      error: () => {},
    });
  }

  public onSubmit(): void {
    if (!this.contactForm.valid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this._spinnerService.show('Submitting your request...');

    let model: ICreateContactUsSubmission = {
      email: this.contactForm.get('email')?.value,

      phone: this.contactForm.get('phone')?.value,

      message: this.contactForm.get('message')?.value,

      subject: this.contactForm.get('subject')?.value,

      name: this.contactForm.get('name')?.value,
    };

    this._contactUsSubmissionService
      .create(model)
      .pipe(
        finalize(() => {
          this._spinnerService.hide();
        }),
      )
      .subscribe({
        next: (response) => {
          if (response.isSuccess) {
            if (response.data === true) {
              this.isSubmitted = true;
              this._ref.markForCheck();
              this.contactForm.reset();

              setTimeout(() => {
                this.closeModal.emit('close');
              }, 5000);
            }
          }
        },
      });
  }
}
